module.exports = __webpack_public_path__ + "img/b2b_logo.912eff1f.png";